import React from 'react';
import Loadable from 'react-loadable';

import { FooterTheme } from '@rover/kibble/styles';
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';

import Loading from '../client/Loading';

export const INBOX_PATH = '/account/inbox/:slug?';
export const UPDATE_EMAIL_PATH = '/account/profile/update-email/';
export const UPDATE_EMAIL_SITTER_PATH = '/provider-profile/update-email/';
export const CONVERSATION_PATH = '/account/conversations/:opk/';
export const STAY_PATH = '/account/stays/:opk/';
export const CONVERSATION_DETAILS_PATH = '/account/conversations/:opk/details/';

const InboxPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "InboxPage" */
        '@rover/pages/src/account/InboxPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});

const UpdateEmailPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "UpdateEmailPage" */
        '@rover/react-lib/src/pages/account/UpdateEmailSSRPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});
const UPDATE_EMAIL_ROUTE = {
  component: UpdateEmailPage,
  componentName: 'UpdateEmailPage',
  exact: true,
  cacheTag: ['page-account-update-email'],
  pageName: 'ssr-account-update-email',
};

const ConversationPage = Loadable({
  loader: (): Promise<React.ComponentType> =>
    retry(() =>
      import(
        /* webpackChunkName: "ConversationPage" */
        '@rover/pages/src/account/ConversationPage'
      ).then((module) => module.default as React.ComponentType)
    ),
  loading: Loading,
});
const CONVERSATION_ROUTE = {
  component: ConversationPage,
  componentName: 'ConversationPage',
  exact: true,
  cacheTag: ['page-account-conversation'],
  pageName: 'ssr-account-conversation',
  suppressFooter: true,
};

const routes: Route[] = [
  {
    path: INBOX_PATH,
    component: InboxPage,
    componentName: 'InboxPage',
    exact: true,
    cacheTag: ['page-account-inbox'],
    pageName: 'ssr-account-inbox',
  },
  {
    path: UPDATE_EMAIL_PATH,
    ...UPDATE_EMAIL_ROUTE,
  },
  {
    path: UPDATE_EMAIL_SITTER_PATH,
    ...UPDATE_EMAIL_ROUTE,
  },
  {
    path: CONVERSATION_PATH,
    ...CONVERSATION_ROUTE,
  },
  {
    path: STAY_PATH,
    ...CONVERSATION_ROUTE,
  },
  {
    path: CONVERSATION_DETAILS_PATH,
    ...CONVERSATION_ROUTE,
  },
].map((route) => ({
  ...route,
  pageCategory: 'ssr-account',
  concept: CONCEPTS.bookings.inbox,
  footerTheme: FooterTheme.LIGHT,
  cacheTag: [...route.cacheTag, 'page-account', 'page-all'],
  isReactQueryRoute: true,
}));

export default routes;
